import type { JobAd } from "@/modules/jobAds/client/api/types"

import dynamic from "next/dynamic"
import { Fragment, type FunctionComponent } from "react"

import { COMPANY_PAGE_TYPE } from "@/modules/companies/client/api/endpoints/company"
import { RECRUITMENT_PATTERN_ID } from "@/modules/companies/client/components/RecruitmentPatternInformation/RecruitmentPatternInformation"
import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"
import { JobAdWrapper } from "@/modules/jobAds/client/components/JobAdWrapper/JobAdWrapper"

import styles from "./JobAdsResults.module.css"

type JobAdsResultProps = {
  jobAds: JobAd[]
  company: {
    id: string
    name: string
  }
}

const RecruitmentPatternBannerDynamic = dynamic(() =>
  import("@/modules/companies/client/components/RecruitmentPatternBanner/RecruitmentPatternBanner").then(
    mod => mod.RecruitmentPatternBanner
  )
)

export const JobAdsResults: FunctionComponent<JobAdsResultProps> = ({ jobAds, company }) => {
  const { dataCompany } = useCompanyFetch()

  const companyDataTrack = { id: company.id, name: company.name }
  const premiumCompany = dataCompany?.pageType === COMPANY_PAGE_TYPE.PREMIUM

  return (
    <ul className={styles.jobAdsResults}>
      {jobAds.map((jobAd, index) => {
        const displayRecruitmentBanner = jobAds.length > 4 && index === 2 && premiumCompany

        return (
          <Fragment key={displayRecruitmentBanner ? RECRUITMENT_PATTERN_ID : jobAd.id}>
            {displayRecruitmentBanner && (
              <li data-testid="company_job_ads_results_banner">
                <RecruitmentPatternBannerDynamic
                  companyDataTrack={companyDataTrack}
                  href={`#${RECRUITMENT_PATTERN_ID}`}
                  className={styles.jobAdsResults__banner}
                />
              </li>
            )}
            <JobAdWrapper key={jobAd.id} jobAd={jobAd} />
          </Fragment>
        )
      })}
    </ul>
  )
}
